<template src="./OrkStock.html"></template>
<style lang="scss" src="./OrkStock.scss"></style>

<script>
import {
    SfAlert,
    SfButton,
    SfInput,
    SfNotification
} from '@storefront-ui/vue';
import ProductOptions from "@/utils/product_options";
import Api from "@/api/Api";

export default {
    name: 'OrkStock',
    components: {
        SfAlert,
        SfButton,
        SfInput,
        SfNotification
    },
    props: {
        stockModal: {type: Boolean, default: false},
        offerId: {type: String},
        quantity: {type: Number},
        showNoStock: {type: Boolean, default: true}
    },
    data() {
        return {
            errorMessage: null,
            loading: false,
            error: false,
            valid: false,
            submitted: false,
            email: "",
            emailBlur: true,
            success: false,
            minimalQuantity: ProductOptions.getProductOptions.minimalQuantity
        }
    },
    computed: {
        customer: {
            get() {
                return this.$store.getters.getProfile
            }
        },

    },
    watch: {
        customer(newVal, oldVal) {
            if (newVal.email) {
                this.email = newVal.email
            }
        }
    },
    methods: {
        validate() {
            this.emailBlur = false;
            if (
                this.validEmail(this.email)
            ) {
                this.valid = true;
            }
        },
        validEmail(email) {
            const regex = /(.+)@(.+){2,}\.(.+){2,}/
            const hasWhiteSpace = /\s/;
            if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
                return true;
            } else {
                return false;
            }
        },
        submitStockAlert() {
            this.validate()
            if (this.valid) {
                this.loading = true;
                Api.product.restockAlert({email: this.email, offerId: this.offerId}).then((data) => {

                    this.error = false
                    this.errorMessage = null;
                    this.success = true
                }).catch((e) => {
                    if (e.status === 409) {
                        this.errorMessage = this.$i18n.t("stockAlert.errorMailExist")
                    } else {
                        this.errorMessage = this.$i18n.t("errors.server.access")
                    }
                    this.error = true
                    this.success = false
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
};
</script>